module.exports = __webpack_public_path__ + "img/logo-removebg-preview.9a671845.png";